import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './VolumeControl.css';
import React, { useState } from 'react';
import { ReactComponent as VolumeOn } from '../../resources/icons/volumeOn.svg';
import { ReactComponent as VolumeOff } from '../../resources/icons/volumeOff.svg';
import { ReactComponent as VolumeMid } from '../../resources/icons/volumeMid.svg';
var VolumeControl = function VolumeControl(_ref) {
  var setVolume = _ref.setVolume,
    _ref$volume = _ref.volume,
    volume = _ref$volume === void 0 ? 0 : _ref$volume;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSlider = _useState2[0],
    setShowSlider = _useState2[1];
  var styleObject = {
    '--min': 0,
    '--max': 100,
    '--step': 1,
    '--value': volume,
    '--text-value': volume ? "" + volume : 0,
    '--prefix': "$"
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(audioControll)
  }, /*#__PURE__*/React.createElement("div", {
    className: "audioControll"
  }, /*#__PURE__*/React.createElement("button", {
    title: "Volume control buttonRow__btn--btn-lvl1",
    onClick: function onClick() {
      return setVolume(volume != 0 ? 0 : 50);
    },
    onKeyPress: function onKeyPress(e) {
      if (e.which === 13) {
        e.preventDefault();
        setVolume(volume != 0 ? 0 : 50);
      }
    },
    onFocus: function onFocus() {
      setShowSlider(true);
    },
    onBlur: function onBlur() {
      setShowSlider(false);
    },
    className: "audio-controll__icon btn--reset"
  }, volume != 0 ? volume > 50 ? /*#__PURE__*/React.createElement(VolumeOn, null) : /*#__PURE__*/React.createElement(VolumeMid, null) : /*#__PURE__*/React.createElement(VolumeOff, null)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(showSlider ? 'range-slider--visible' : '', " range-slider grad"),
    style: styleObject
  }, /*#__PURE__*/React.createElement("input", {
    title: "Volume control",
    value: volume,
    type: "range",
    min: "0",
    max: "100",
    step: "1",
    onChange: function onChange(e) {
      setTimeout(function (a) {
        return function () {
          setVolume(a);
        };
      }(e.target.value), 0);
    },
    onFocus: function onFocus() {
      setShowSlider(true);
    },
    onBlur: function onBlur() {
      setShowSlider(false);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "range-slider__progress"
  }))));
};
export var audioControll = "azadk4r";
export default VolumeControl;